import type { RudderstackAccessDenial } from '@/_shared/contexts/WorkspaceContext';

/**
 * The badge of a workspace that the RudderStack membership check denies (ACT2-1124 §5.7), in one or two words. The
 * server's message, which says why and what to do, goes in the tooltip.
 */
export function accessDenialBadge(denial: RudderstackAccessDenial): string {
  if (denial.reason === 'suspended') return 'Suspended';
  if (denial.reason === 'no_access') return 'No access';
  return 'Unavailable';
}
